export const QUICK_LINK_COLORS = ['#f9b500', '#f9d500', '#ffedad', '#ffffff', '#cccccc'];

export const TRIGGER_NOTIFICATION_BELL_ANIMATION: string = 'trigger-notification-bell-animation';
export const REFRESH_NOTIFICATIONS_OVERVIEW: string = 'refresh-notifications-overview';
export const NOTIFICATION_CENTER_OVERVIEW_BUS: string = 'notification-center-overview-bus';

export const FALLBACK_LANGUAGE = 'de';

export const OPTIONAL_COOKIES_KEY = 'cb-enabled';
export const OPTIONAL_COOKIES_ACCEPTED_VALUE = 'accepted';

export const sanitizationOptionsSmall = {
    allowedTags: [
        'a', 'b', 'i', 'strong', 'em', 'strike', 'span', 'br',
    ],
    allowedAttributes: {
        a: ['href'],
        '*': ['style', 'alt'],
    },
};

export const sanitizationOptionsFull = {
    allowedTags: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote',
        'p', 'a', 'ul', 'ol', 'nl', 'li', 'b',
        'i', 'strong', 'em', 'strike', 'code',
        'hr', 'br', 'div', 'table', 'thead',
        'caption', 'tbody', 'tr', 'th', 'td',
        'pre', 'img', 'span'],
    allowedAttributes: {
        a: ['href'],
        img: ['src'],
        '*': ['style', 'alt'],
    },
};
